module.exports = __webpack_public_path__ + "img/home-06-compare-handle.ce4e0689.png";